























































































































































import Component from 'vue-class-component'
import RespondecoDialog from '@/main/dialog.vue'
import RespondecoDialogButtons from '@/main/dialog-buttons.vue'
import RespondecoDialogButton from '@/main/dialog-button.vue'
import { Drop } from 'vue-drag-drop'
import { Injector } from '@/config/dependency-injection'
import { ResourceDialogDataSource } from '@/shared/components/resource-dialog/resource-dialog-data-source'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import RespondecoStepper from '@/shared/components/respondeco-stepper.vue'
import RespondecoStep from '@/shared/components/respondeco-step.vue'
import RespondecoImage from '@/shared/components/respondeco-image.vue'
import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'
import { Steppable } from '@/shared/interfaces/steppable'
import { ResourceVariant } from '@/api/generated'
import Dialog from '@/shared/dialog/dialog'
import { NotificationService } from '@/shared/services/notification-service'
import ResourceToolbar from '@/business/resource/components/resource-toolbar.vue'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'
import RespondecoToolbarItem from '@/shared/components/toolbar/respondeco-toolbar-item.vue'
import ResourceItem from '@/business/resource/components/resource-item.vue'
import RespondecoDropArea from '@/shared/components/respondeco-drop-area.vue'
import { imageUrl } from '@/shared/utils/images'
import { ExtendedBlob } from '@/shared/models/extended-blob'
import { imageDialog } from '@/main/image-dialog'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import RespondecoFileInput from '@/shared/components/respondeco-file-input.vue'
import { ResourceType } from '@/business/resource/interfaces/resource-type'
import { ResourceDialogSteps } from '@/shared/components/resource-dialog/resource-dialog-steps'
import { Prop } from 'vue-property-decorator'
import { ResourceDialogInput } from '@/shared/components/resource-dialog/resource-dialog-input'
import { TypedForm } from '@/shared/forms/typed-form'
import {
  ResourceDialogForm,
  resourceDialogFormMapping,
} from '@/shared/components/resource-dialog/resource-dialog-form'
import { ResourceDialogOutput } from '@/shared/components/resource-dialog/resource-dialog-output'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import { Hooks } from '@/shared/interfaces/hooks'
import { ResourceVariantViewModel } from '@/business/resource/interfaces/resource-variant-view-model'
import RespondecoRejectedFilesAlert from '@/shared/components/respondeco-rejected-files-alert.vue'
import { RejectedFile } from '@/shared/models/rejected-file'
import { WithId } from '@/shared/utils/with-id'
import RespondecoIcon from '@/shared/components/respondeco-icon.vue'

@Component({
  name: 'resource-dialog',
  components: {
    RespondecoIcon,
    RespondecoRejectedFilesAlert,
    UnifyFormInput,
    UnifyListItem,
    UnifyListItemLabel,
    UnifyListItemContent,
    UnifyList,
    RespondecoForm,
    RespondecoFileInput,
    UnifyButton,
    RespondecoDropArea,
    RespondecoToolbarItem,
    ResourceItem,
    RespondecoToolbar,
    ResourceToolbar,
    RespondecoImage,
    RespondecoStep,
    RespondecoStepper,
    RespondecoLoadingIndicator,
    Drop,
    RespondecoDialogButton,
    RespondecoDialogButtons,
    RespondecoDialog,
  },
})
export default class ResourceDialog extends Dialog<ResourceDialogOutput>
  implements Hooks, ResourceDialogInput {
  @Prop({
    default: () => 'both',
    type: String,
  })
  public readonly allowedType!: 'image' | 'video' | 'both'

  @Prop({
    default: Number.NaN,
    type: Number,
  })
  public readonly aspectRatio!: number

  @Prop({
    default: () => [],
    type: Array,
  })
  public readonly exclude!: WithId[]

  @Prop({
    type: String,
  })
  public readonly title!: string

  public form!: TypedForm<ResourceViewModel, ResourceDialogForm>

  public rejectedFiles: RejectedFile[] | null = null

  private dataSource = Injector.get(ResourceDialogDataSource)
  private notificationService = Injector.get(NotificationService)

  private stepper: Steppable | null = null

  get activeStep(): string | undefined {
    return this.stepper?.activeStepId
  }

  get canSelectType(): boolean {
    return this.allowedType === 'both'
  }

  get images(): ResourceViewModel[] {
    return this.resources.filter(resource => resource.type === ResourceType.FILE)
  }

  get loading(): boolean {
    return this.dataSource.isLoading()
  }

  get resources(): ResourceViewModel[] {
    const find = (item: ResourceViewModel) =>
      this.exclude.find(toExclude => {
        const exists = toExclude.id === item.id
        const hasVariants = item.variants !== undefined && item.variants.length > 0

        return exists && hasVariants === false
      })

    return this.dataSource.items.filter(item => find(item) === undefined)
  }

  get selectedResource(): ResourceViewModel | undefined {
    let resource = this.resources.find(item => item.id === this.form.value.resource?.id)

    if (resource !== undefined) {
      const variant: ResourceVariantViewModel = {
        id: resource.id,
        location: resource.location,
        type: resource.type,
      }

      // Prepend the original resource
      resource = {
        ...resource,
        variants: [variant, ...resource.variants],
      }

      // And select it
      this.form.patch({
        variant,
      })
    }

    return resource
  }

  get videos(): ResourceViewModel[] {
    return this.resources.filter(resource => resource.type === ResourceType.VIDEO)
  }

  public mounted() {
    this.dataSource.fetchData()
  }

  public data() {
    return {
      form: new TypedForm(resourceDialogFormMapping(), this),
    }
  }

  public validations() {
    return this.form.validations()
  }

  /**
   * Select the given resource and go to the second step
   */
  public choose(resource: ResourceViewModel): void {
    this.form.patch({
      resource,
      variants: [resource, ...resource.variants],
    })

    this.goToStep('variant')
  }

  public chooseVideo(resource: ResourceViewModel): void {
    this.form.patch({
      location: resource.location,
    })
  }

  public createFiles(files: File[]): void {
    for (const file of files) {
      this.dataSource.createResource(file).catch(
        this.notificationService.errorHandler({
          400: 'resources.create.upload_failed.wrongFileType',
        })
      )
    }
  }

  public createVariant(resource: ResourceViewModel): void {
    imageDialog({
      aspectRatio: this.aspectRatio,
      file: imageUrl(resource.location),
    }).submitted((file: ExtendedBlob) => {
      this.dataSource
        .createVariant(file, resource)
        .then(
          this.notificationService.successHandler('resources.actions.add_variant.success'),
          this.notificationService.errorHandler('resources.actions.add_variant.failure')
        )
    })
  }

  public dismiss(): void {
    this.dialogRef.dismiss().close()
  }

  public emitImage(resourceVariant: ResourceVariant): void {
    this.emit({
      ...resourceVariant,
      description: this.selectedResource?.description,
      name: this.selectedResource?.name,
    })
  }

  public emitVideo(location: string): void {
    this.emit({
      location,
      type: ResourceType.VIDEO,
    })
  }

  public goBackTo(id: ResourceDialogSteps): void {
    this.form.reset()

    this.goToStep(id)
  }

  public goToStep(id: ResourceDialogSteps): void {
    if (id === 'image' && this.resources.length === 0) {
      this.dataSource.fetchData().catch(this.notificationService.errorHandler())
    }

    this.stepper?.select(id)
  }

  public hideRejectedFiles(): void {
    this.rejectedFiles = null
  }

  public initialize(): void {
    this.stepper = (this.$refs.stepper as unknown) as Steppable

    if (this.allowedType !== 'both') {
      this.goToStep(this.allowedType)
    }
  }

  public setVariant(variant: ResourceVariant): void {
    this.form.patch({
      variant,
    })
  }

  public showRejectedFiles(rejectedFiles: RejectedFile[]): void {
    this.rejectedFiles = rejectedFiles
  }

  private emit(resource: ResourceDialogOutput): void {
    this.dialogRef.submit(resource).close()
  }
}
